module.exports = __webpack_public_path__ + "static/media/al.839a58d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/al.png
// module id = 1780
// module chunks = 0